module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = 1073
// module chunks = 20